<zxing-scanner
  [formats]="labelTypes"
  (scanComplete)="onSuccess($event)"
  (scanError)="onFailure()"
  [autostart]="true"
  #scanner
></zxing-scanner>
